import { categories } from "@/mocks/discussion";
import { toneSoft, toneDot } from "./tones";

export default function CategoryBoard({ onSelect }: { onSelect: (name: string) => void }) {
  return (
    <section id="category" className="bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-3 md:flex-row md:items-end">
          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-primary-500">围观专区</p>
            <h2 className="section-title mt-2 text-2xl text-foreground-950 md:text-3xl">想去哪里围观，一键直达</h2>
          </div>
          <p className="max-w-md text-sm text-foreground-600">
            六大热议专区，按你感兴趣的方向快速定位，点击即可筛选对应话题。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat) => (
            <button
              key={cat.id}
              type="button"
              onClick={() => onSelect(cat.name)}
              className="group flex cursor-pointer items-center gap-4 rounded-2xl border border-background-200 bg-background-50 p-5 text-left transition-colors hover:border-primary-200 hover:bg-white"
            >
              <span
                className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl text-xl ${toneSoft[cat.tone]}`}
              >
                <i className={cat.icon} aria-hidden="true"></i>
              </span>
              <span className="min-w-0 flex-1">
                <span className="flex items-center gap-2">
                  <span className={`h-2 w-2 rounded-full ${toneDot[cat.tone]}`}></span>
                  <span className="text-[15px] font-bold text-foreground-950">{cat.name}</span>
                </span>
                <span className="mt-1 block truncate text-xs text-foreground-500">{cat.desc}</span>
              </span>
              <i
                className="ri-arrow-right-s-line text-lg text-foreground-300 transition-all group-hover:translate-x-0.5 group-hover:text-primary-500"
                aria-hidden="true"
              ></i>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}